<template>
  <div class="warning-modal-body">
    <div class="exclamation-mark">
      <AM3Icon
        type="exclamation-triangle"
        height="70px"
      />
    </div>
    <p class="text-center font-medium text-base warning-modal-title whitespace-pre-line">
      Contact sales for access to {{ featureName }}
    </p>
    <p
      class="text-center text-sm warning-modal-message whitespace-pre-line"
      v-html="`You don't have access to ${featureName} yet. For access please <a target='__blank' href='https://audiencerepublic.com/contact-us?type=organizer'>contact sales</a>`"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// definePageMeta({
//   layout: false,
// })

export default {
  name: 'NotAccessiblePage',

  props: {
    featureName: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
.warning-modal-body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 250px;
}
.warning-modal-body .exclamation-mark {
  display: flex;
  justify-content: center;
  margin-bottom: 19px;
}
.warning-modal-body .warning-modal-title {
  margin-bottom: 16px;
}
.warning-modal-body .warning-modal-message {
  color: #43516b;
}
</style>
